import React from 'react';
import CheckmarkIcon from '../assets/green-checkmark.svg';
import './InformationBox.css';

interface InformationBoxProps {
  type: 'success' | 'warning';
  title: string;
  children: React.ReactNode;
}

const InformationBox: React.FC<InformationBoxProps> = ({ type, title, children }) => {
  return (
    <div className={`information-box information-box--${type}`}>
      <div className="information-box-content">
        <div className="information-box-icon">
          <img src={CheckmarkIcon} alt="success" className="success-icon" />
        </div>
        <div className="information-box-text">
          <h4>{title}</h4>
          <div className="information-box-body">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default InformationBox;
